const TabsSection = ({title, desc,name}) => {
    return(
        <div
        className="flex flex-col gap-4 mt-5">
            <h3
            className="font-semibold flex gap-1"
            >
                <span>
                    {title}
                </span>
                <span>
                    {name}
                </span>
            </h3>
            <div
            className="text-justify"
            >
                {desc}
            </div>
        </div>
    )
}
export default TabsSection